import { BffFacility, FacilityFieldsFragment } from '@aspendental/shared-components-web/lib/graphql/__generated/sdk';
import { mountStoreDevtool } from 'simple-zustand-devtools';
import { create } from 'zustand';

type TimeSlot = {
	timeSlot: {
		booked: number;
		date: string;
		datetime: string;
		open: number;
		open_slots: any[];
		ptc: any | null;
		time: string;
	};
};

type AppointmentInformationState = {
	chosenCenterData: BffFacility | FacilityFieldsFragment | null;
	chosenAppointmentData: any | null;
	chosenAppointmentKey: string | null;
	shouldPreserveAppointmentAndCenterData: boolean;
	appointmentsToShow: number;
	presetCenterID: string | null; // < used only for tracking purposes
	presetCenterName: string | null; // < used only for tracking purposes
	// details saved for datalayer
	trackAppoinmtentTimesShown: number;
	trackAppoinmtentDaysShown: number;
};

type AppointmentInformationActions = {
	setChosenCenterData: (centerData: BffFacility | FacilityFieldsFragment | null) => void;
	setChosenAppointmentData: (timeSlot: TimeSlot | unknown) => void;
	setChosenAppointmentKey: (id: string) => void;
	setShouldPreserveAppointmentAndCenterData: (shouldPreserve: boolean) => void;
	setAppointmentsToShow: (appointmentsToShow: number) => void;
	setPresetCenterID: (presetCenterID: string) => void;
	setPresetCenterName: (presetCenterName: string) => void;
	setTrackAppoinmtentTimesShown: (count: number) => void;
	setTrackAppoinmtentDaysShown: (count: number) => void;
};

const useAppointmentInformationStore = create<AppointmentInformationState & AppointmentInformationActions>((set) => ({
	chosenCenterData: null,
	setChosenCenterData: (chosenCenterData) => set({ chosenCenterData }),
	chosenAppointmentData: null,
	setChosenAppointmentData: (chosenAppointmentData) => set({ chosenAppointmentData }), // Fix here
	chosenAppointmentKey: null,
	setChosenAppointmentKey: (chosenAppointmentKey) => set({ chosenAppointmentKey }),
	shouldPreserveAppointmentAndCenterData: false,
	setShouldPreserveAppointmentAndCenterData: (shouldPreserve) =>
		set({ shouldPreserveAppointmentAndCenterData: shouldPreserve }),
	appointmentsToShow: 6,
	setAppointmentsToShow: (appointmentsToShow) => set({ appointmentsToShow }),
	presetCenterID: null,
	setPresetCenterID: (presetCenterID) => set({ presetCenterID }),
	presetCenterName: null,
	setPresetCenterName: (presetCenterName) => set({ presetCenterName }),
	trackAppoinmtentTimesShown: 0,
	setTrackAppoinmtentTimesShown: (trackAppoinmtentTimesShown) => set({ trackAppoinmtentTimesShown }),
	trackAppoinmtentDaysShown: 0,
	setTrackAppoinmtentDaysShown: (trackAppoinmtentDaysShown) => set({ trackAppoinmtentDaysShown }),
}));

if (process.env.NODE_ENV === 'development') {
	mountStoreDevtool('useAppointmentInformationStore', useAppointmentInformationStore);
}

export default useAppointmentInformationStore;
